import { CstEmail } from './cst-email';

export class EmailDTO {
	emailAddr: string="";
	emailTypcode: string;
	primaryFlag: false;
	activeFlag: true;
	effectiveDate: string;
	expiryDate: string;
	validFlag: true;
	validationErrors: string;
	label: string;
	contactPref: string;
	formatPref: string;
	contactFlag: false;
	createUser: string;
	createDate: string;
	updateUser: string;
	updateDate: string;
	description: string;
	cstEmail: CstEmail;

	constructor() {
		this.cstEmail = new CstEmail();
	}

}

